import { useNavigate } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import { Button } from "../../../components/design";

const ServingPromptModal = (props) => {
  const { openModal, URL, setOpenModal, profile } = props;
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const onClose = () => {
    setOpenModal(false);
  };

  return (
    openModal && (
      <Modal
        show={openModal}
        onHide={onClose}
        centered
        className="newmodalui max-w-lg tailwind-base-modal wrapper-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_t(
              "viewProfileLLHeaderForSelfServingTool",
              "Title for popup for self serving tool when LL tries to open a profile and deduction is needed."
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {profile?.tenantid?.email == "demotenant@skortorent.com" ? (
            <p className="text-center">
              {_t(
                "thisIsADemoProfileNormallyItCosts",
                "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
              )}{" "}
              <span className="fw-bold text-decoration-underline">
                {_t(
                  "5Credits",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}
              </span>{" "}
              {_t(
                "toViewANewProfileButThisOneIsFreeSoYouCanTryOutHowTHeInformationLooks",
                "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
              )}
            </p>
          ) : (
            <>
              <p className="text-center">
                {_t(
                  "youWillSpend",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}{" "}
                <span className="fw-bold text-decoration-underline">
                  {_t(
                    "5Credits",
                    "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                  )}
                </span>{" "}
                {_t(
                  "toOpenThisProfileForTheFirstTime",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}
              </p>
              <p className="text-center">
                {_t(
                  "reopeningItLaterIsFreeThisOnlyAppliesToNewProfilesNotOnesYouHaveAlreadyViewed",
                  "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
                )}
              </p>
            </>
          )}
        </Modal.Body>
        <div className="inviteButtonWrapper">
          <Button
            variant="secondary"
            size="lg"
            className="mr-2"
            type="button"
            onClick={onClose}
          >
            {_t("goBack")}
          </Button>
          <Button
            variant="primary"
            size="lg"
            type="button"
            onClick={() => {
              navigate(URL);
            }}
          >
            {_t("continue")}
          </Button>
        </div>
      </Modal>
    )
  );
};

export default ServingPromptModal;
